/* @refresh reload */
import "@fontsource-variable/dm-sans";
import "@fontsource-variable/host-grotesk";
import { render, Show } from "solid-js/web";
import "./index.css";
import { QueryClientProvider } from "@tanstack/solid-query";
import { SolidQueryDevtools } from "@tanstack/solid-query-devtools";
import AppRouter from "./AppRouter";
import { queryClient } from "./api/client";
import postHogClient from "./api/posthog";
import { loadTaxonomy } from "./domains/freelance/taxonomy/api";
import { bootAnalyticsWithConsent } from "./domains/tracking/store/boot";
import { getStoredConsent } from "./domains/tracking/store/consent-store";

const root = document.getElementById("root");

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",
  );
}

// Reads the persisted consent BEFORE init so PostHog starts already in the right
// state (capture only if analytics were accepted; otherwise opt-out + memory).
bootAnalyticsWithConsent({ getStoredConsent }, postHogClient);

// The taxonomy labels are requested once at startup, logged in or not, and never awaited: the
// screens show the keys until they arrive (taxonomy-labels spec, AC5 and AC8).
void loadTaxonomy();

render(
  () => (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
      <Show when={import.meta.env.DEV}>
        <SolidQueryDevtools />
      </Show>
    </QueryClientProvider>
  ),
  root!,
);
